import team from '../../constants/team'
import AboutTeam from './AboutTeam';

const AboutTeamContainer = () => {  

    return (
        <>
            <AboutTeam team={team} />
        </>
    );
};


export default AboutTeamContainer;
